// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface Props {
  /**
   * If true, the dialog will be displayed.
   */
  isOpen: boolean;

  /**
   * A callback fired when the dialog requests to be closed.
   */
  onClose: () => void;

  /**
   * A callback fired when the user clicks the retry action.
   */
  onRetry: () => void;
}

/**
 * A dialog for file upload errors that provides a clear explanation
 * and allows the user to select a new file.
 *
 * This dialog is shown when a file becomes inaccessible after selection
 * (e.g., moved, deleted, or permissions changed).
 */
export function UploadErrorDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="sm" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Unable to upload file</DialogTitle>
      <DialogContent dividers>
        <Typography marginBottom={1}>
          The selected file could not be read. This can happen if the file was
          moved, deleted, or its permissions were changed after you selected it.
        </Typography>
        <Typography>Please select the file again to upload it.</Typography>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={props.onClose}>
          Cancel
        </Button>
        <Button size="small" variant="contained" onClick={props.onRetry}>
          Select new file
        </Button>
      </DialogActions>
    </Dialog>
  );
}
